import {CONSTANT} from '@/constants/components/modals/add-scorecard-constant';
import { CustomToastrAction } from "@/imports-files/common/common";
import {AddScorecardService} from '@/services/components/modal/add-scorecard-service.js'
import PageStyle from "@/styles/pages/jobs/view-scorecards/_index.module.scss";
import { ApplicationFilter } from '@/actions/common/application-filter';
// ---- RED ----
import OneRatingRed from 'public/icons/rating/1red.svg'
import TwoRatingRed from 'public/icons/rating/2red.svg'
// // ---- RED ----

// ---- YELLOW ----
import OneRatingYellow  from 'public/icons/rating/1yellow.svg'
import TwoRatingYellow  from 'public/icons/rating/2yellow.svg'
import ThreeRatingYellow from 'public/icons/rating/3yellow.svg'
// // ---- YELLOW ----

// ---- GREEN ----
import OneRatingGreen  from 'public/icons/rating/1green.svg'
import TwoRatingGreen  from 'public/icons/rating/2green.svg'
import ThreeRatingGreen from 'public/icons/rating/3green.svg'
import FourRatingGreen from 'public/icons/rating/4green.svg'
import FiveRatingGreen from 'public/icons/rating/5green.svg'
// // ---- GREEN ----
//
import OneRating from 'public/images/pages/scorecard/ratings/rating1.svg';
import TwoRating from 'public/images/pages/scorecard/ratings/rating2.svg';
import ThreeRating from 'public/images/pages/scorecard/ratings/rating3.svg';
import FourRating from 'public/images/pages/scorecard/ratings/rating4.svg';
import FiveRating from 'public/images/pages/scorecard/ratings/rating5.svg';


// Sub Competency Icons
import OneSubRating from 'public/images/pages/scorecard/ratings/sub-rating1.svg';
import TwoSubRating from 'public/images/pages/scorecard/ratings/sub-rating2.svg';
import ThreeSubRating from 'public/images/pages/scorecard/ratings/sub-rating3.svg';
import FourSubRating from 'public/images/pages/scorecard/ratings/sub-rating4.svg';
import FiveSubRating from 'public/images/pages/scorecard/ratings/sub-rating5.svg';


export class AddScorecardAction
{
	constructor(router)
	{
		this.router = router;
		this.addScorecardService = new AddScorecardService();
		this.customToastrAction = new CustomToastrAction();
	}


	async submitForm(values, setShowScorecardPopup, setFlagForRerender, props, setSubmitButtonDisabled, hideAddScorecard, setShowLoader)
	{
		setSubmitButtonDisabled(true);
		setShowLoader(true)
		let applicant_id = this.router.query.applicant_id;
		if (props.from == 'application_view'){
			values.kanban = {candidate_index: props.candidateIndex, base_stage_id: props.paramStageId}
			let filterData = ApplicationFilter(values.current_job_id);
	    if(filterData){
	      values.application_filter_data = filterData;
	    }
		}

		let result = await this.addScorecardService.addScorecard(values, applicant_id);

		if(result?.status == 200)
	    {
	        this.customToastrAction.setNormalToastr( result.data.success, "success");

	        props.initialData.application.scorecard_value = result.data.overall_score;
	        props.initialData.application.overall_score   = result.data.overall_score;
        	props.initialData.scorecards                  = result.data.scorecards;
        	props.initialData.add_scorecard               = result.data.add_scorecard
        	setShowScorecardPopup(false);
        	hideAddScorecard();
        	await props.setInitialData(result.data);
        }
	    else
	    {
	    	this.customToastrAction.setNormalToastr(result.response.data.error, 'warning'); 
	    }

	    /*setFlagForRerender(Math.random()*1000);*/
	    setShowLoader(false)
	    setSubmitButtonDisabled(false);
	}

	setFormInitialValues(formData,index)
	{
		let scorecard_score_hash = [];
		let type = typeof index != 'undefined' ? 'edit' : 'create';

		if(type=='create')
		{
			if(!formData.scorecard_link)
			{
				for(let element of formData.competencies)
				{
					let sub_hash = ''
					let form_hash = {	"job_competency_id": element.job_competency_id,
										"score" : '',
										"info": '',
										"job_sub_competencies":[],
										"job_competency_name": element.job_competency_name,
										"job_competency_notes": element.job_competency_notes
									}

					for(let sub_competency of element.job_sub_competency_names)
					{
						sub_hash = {
										  "job_sub_competency_id": sub_competency.job_sub_competency_id,
		            					  "score":'',
		            					  "info":'',
		            					  "job_sub_competency_name":sub_competency.job_sub_competency_name,
		            					  "job_sub_competency_notes": sub_competency.job_sub_competency_notes
		            				} 
		            	form_hash.job_sub_competencies.push(sub_hash);
					}


					scorecard_score_hash.push(form_hash);
				}
			}
			else
			{
				let form_hash = {	"score" : '',
									"link": ''
								}
				scorecard_score_hash.push(form_hash);
			}
		}
		else
		{
			if(formData.scorecards[index].score_hash.length > 0)
			{
				scorecard_score_hash = formData.scorecards[index].score_hash;
			}
			else
			{
				if(!formData.scorecard_link)
				{
					for(let element of formData.competencies)
					{
						let sub_hash = ''
						let form_hash = {	"job_competency_id": element.job_competency_id,
											"score" : '',
											"info": '',
											"job_sub_competencies":[],
											"job_competency_name": element.job_competency_name,
											"job_competency_notes": element.job_competency_notes
										}

						for(let sub_competency of element.job_sub_competency_names)
						{
							sub_hash = {
											  "job_sub_competency_id": sub_competency.job_sub_competency_id,
			            					  "score":'',
			            					  "job_sub_competency_name":sub_competency.job_sub_competency_name,
			            					  "job_sub_competency_notes": sub_competency.job_sub_competency_notes
			            				} 
			            	form_hash.job_sub_competencies.push(sub_hash);
						}


						scorecard_score_hash.push(form_hash);
					}
				}
				else
				{
					let form_hash = {	"score" : '',
										"link": ''
									}
					scorecard_score_hash.push(form_hash);
				}
			}
		}
		CONSTANT.scorecard.empty = ''; // TO Print empty text area in download pdf
		CONSTANT.scorecard.score_hash = scorecard_score_hash;
		CONSTANT.scorecard.overall_feedback = formData.scorecards[index]?.overall_feedback || '';
		CONSTANT.current_job_id = this.router.query.job_id;
		return CONSTANT;
	}

	addComment(formik, setComment, index)
	{
		let heading = formik.values.scorecard.score_hash[index]?.info && formik.values.scorecard.score_hash[index]?.info != '' ? 'Edit Comment' : 'Add Comment';
		setComment({status:true, index: index, heading: heading, submitButtonAction: this.submitCommentSection});
	}

	submitCommentSection(params)
	{
		if(params.formik)
    	{
    		params.formik.setFieldValue(params.name, params.value);
    	}
    	params.setModal({status: false, heading: '', index: params?.index, submitButtonAction:''});

	}

	setColorClass(value, type='competency')
	{
		if(type=='competency')
		{
			let scoreValue = parseFloat(value)
		    if(scoreValue == NaN)
		      return 'RedBg'
		    else if(scoreValue <= 2)
		      return 'RedBg'
		    else if(scoreValue > 2 && scoreValue < 4)
		      return 'YellowBg'
		    else if(scoreValue >= 4)
		      return 'GreenBg'
		    else 
		      return 'RedBg'
		}
		else
		{
			return 'Default';
		}
	}


	isNotesPresent(competency_id, competencies)
	{
		for(let competency of competencies)
    	{
    		if(competency.job_competency_id == competency_id && competency.job_competency_notes && competency.job_competency_notes != '')
    		{
    			return true;
    		}
    	}

    	return false;
	}


	getNotesData(competency_id, competencies)
	{
		for(let competency of competencies)
    	{
    		if(competency.job_competency_id == competency_id && competency.job_competency_notes && competency.job_competency_notes != '')
    		{
    			return competency.job_competency_notes;
    		}
    	}
	}
	// --------------------------

	colorHoverRatingSymbolArray(value, name, type='subcompetency_color', selected_score_value)
	{
		let fill_ratings = document.querySelectorAll(`.${name} .FillRating`);
		let empty_ratings = document.querySelectorAll(`.${name} .EmptyRating`);
		value = typeof value == 'undefined' ? selected_score_value : value;
		fill_ratings.forEach((rating,index) => 
		{

			if(index < value)
			{
				if(type =='competency_color')
				{
					rating.classList.remove('RedBg');
					rating.classList.remove('YellowBg');
					rating.classList.remove('GreenBg');
					rating.classList.remove('Default');
					// rating.classList.add(this.setColorClass(value));

					let empty_rating = empty_ratings[index];
					empty_rating.classList.remove('RedBg');
					empty_rating.classList.remove('YellowBg');
					empty_rating.classList.remove('GreenBg');
					empty_rating.classList.remove('Default');
					// empty_rating.classList.add(this.setColorClass(value));
				}
				else
				{	
					rating.classList.remove('RedBg');
					rating.classList.remove('YellowBg');
					rating.classList.remove('GreenBg');
					rating.classList.remove('Default');

					let empty_rating = empty_ratings[index];
					empty_rating.classList.remove('RedBg');
					empty_rating.classList.remove('YellowBg');
					empty_rating.classList.remove('GreenBg');
					empty_rating.classList.remove('Default');
				}
			}
			else
			{
				rating.classList.remove('RedBg');
				rating.classList.remove('YellowBg');
				rating.classList.remove('GreenBg');
				rating.classList.remove('Default');
				// rating.classList.add('Default');

				let empty_rating = empty_ratings[index];
				empty_rating.classList.remove('RedBg');
				empty_rating.classList.remove('YellowBg');
				empty_rating.classList.remove('GreenBg');
				empty_rating.classList.remove('Default');
				// empty_rating.classList.add('Default');

			}

			let svg = rating.querySelector('svg');
			if(index < value)
			{
				if(type=='subcompetency_color')
				{
					let empty_svg = empty_ratings[index].querySelector('svg');
					// this.setDefultFilledColor(svg);
					// this.setDefultFilledColor(empty_svg);
					this.setCompetencyColor(svg, value);
					this.setCompetencyColor(empty_svg, value);
				}
				else
				{
					let empty_svg = empty_ratings[index].querySelector('svg');
					this.setCompetencyColor(svg, value);
					this.setCompetencyColor(empty_svg, value);
				}
			}
			else
			{
				let empty_svg = empty_ratings[index].querySelector('svg');
				this.setDefultColor(empty_svg, type);
				this.setDefultColor(svg, type);
			}
		})
	}

	setColor(value)
	{
		let redColor = "var(--default-error-color)";
		let yellowColor = "var(--default-yellow-color)";
		let greenColor = 'var(--default-success-color)';
		 switch(value)
		 {
		 		case 1: return redColor
		 		case 2: return redColor;
		 		case 3: return yellowColor;
		 		case 4: return greenColor;
		 		case 5: return greenColor;
		 		default: return redColor;
		 }
	}

	onChangeRating(name, formik, value, field_name, type)
	{
		formik.setFieldValue(name, value);
		let fill_ratings = document.querySelectorAll(`.${field_name} .FillRating`);
		// let empty_ratings = document.querySelectorAll(`.${field_name} .EmptyRating`);
		
		fill_ratings.forEach((rating,index) => 
		{
			rating.classList.remove('RedBg');
			rating.classList.remove('YellowBg');
			rating.classList.remove('GreenBg');
			// rating.classList.add(this.setColorClass(value));

				let svg = rating.querySelector('svg');
					if(index < value)
					{
						this.setCompetencyColor(svg, value);
					}
					else
					{
						let fill_svg = fill_ratings[index].querySelector('svg');
						this.setDefultColor(fill_svg, type);
					}
		})
	}


	setCompetencyColor(svg, value)
	{
		let rect = svg.querySelector('rect');
		let path = svg.querySelector('path');
		let color = this.setColor(value)
		// svg.setAttribute('fill','none');
		// svg.style.backgroundColor = color;
		// rect.setAttribute('stroke',color);
		rect.setAttribute('fill', color);
		path.setAttribute('fill','white');
	}

	setDefultColor(svg, type)
	{
		let rect = svg.querySelector('rect');
		let path = svg.querySelector('path');
		// let color = "#99ADBD";
		let color = type == 'subcompetency_color' ? 'var(--default-primary-color)' : 'white'
		// svg.setAttribute('fill','none');
		// svg.style.backgroundColor = type == 'subcompetency_color' ? 'var(--default-primary-color)' : 'white';
		// rect.setAttribute('stroke',color);
		rect.setAttribute('fill', color);

		// rect.setAttribute('height', 56);
		// rect.setAttribute('width', 100);
		// rect.setAttribute('stroke-width', '2');
		// rect.setAttribute('x', 1);
		// rect.setAttribute('y', 1);
		path.setAttribute('fill', "var(--default-secondary-color)");
	}


	setDefultFilledColor(svg)
	{
		let rect = svg.querySelector('rect');
		let path = svg.querySelector('path');
		let color = "#99ADBD";
		svg.setAttribute('fill','none');
		svg.style.backgroundColor = color;
		rect.setAttribute('stroke',color);
		rect.setAttribute('fill', 'none');

		rect.setAttribute('height', 24);
		rect.setAttribute('width', 25);
		rect.setAttribute('stroke-width', '2');
		rect.setAttribute('x', 1);
		rect.setAttribute('y', 1);
		path.setAttribute('fill', 'white');
	}

	calculateOverallScore(sub_competencies)
	{
		let competency_score = 0;
		let total = 0;
		for(let element of sub_competencies)
		{
			competency_score = competency_score + parseFloat(element.score || 0);
			if(element.score != 0 && element.score!='')
			{
				total = total + 1;
			}
		}

		if(total == 0) return 0
		competency_score = competency_score/total;
		return Number.isInteger(competency_score) ? competency_score : competency_score.toFixed(1)
		// return competency_score.slice(0, (competency_score.indexOf(".")) + 2);
	}

	getOverallScoreColor(sub_competencies)
	{
			let value = this.calculateOverallScore(sub_competencies)
		 	let scoreValue = parseFloat(value)
		    if(scoreValue == NaN)
		      return 'RedBg'
		    else if(scoreValue <= 2)
		      return 'RedBg'
		    else if(scoreValue > 2 && scoreValue < 4)
		      return 'YellowBg'
		    else if(scoreValue >= 4)
		      return 'GreenBg'
		    else 
		      return 'GreenBg'
	}

	submitCommentSection(params)
	{
		if(params.formik)
    	{
    		params.formik.setFieldValue(params.name, params.value);
    	}
    	params.setModal({status: false, heading: '', index: params?.index, submitButtonAction:''});

	}

	isNotesPresent(competency_id, competencies)
	{
		for(let competency of competencies)
    	{
    		if(competency.job_competency_id == competency_id && competency.job_competency_notes && competency.job_competency_notes != '')
    		{
    			return true;
    		}
    	}

    	return false;
	}


	getNotesData(competency_id, competencies)
	{
		for(let competency of competencies)
    	{
    		if(competency.job_competency_id == competency_id && competency.job_competency_notes && competency.job_competency_notes != '')
    		{
    			return competency.job_competency_notes;
    		}
    	}
	}

	 initalArray(value, type)
	  {
	    let scoreValue = parseFloat(value)
	    if(scoreValue == NaN)
	      return type == 'subcompetency' ? [<OneSubRating/>,<TwoSubRating/>,<ThreeSubRating/>,<FourSubRating/>,<FiveSubRating/>] : [<OneRating/>,<TwoRating/>,<ThreeRating/>,<FourRating/>,<FiveRating/>]
	    else if(scoreValue <= 2)
	      return type == 'subcompetency' ? [<OneRatingRed/>,<TwoRatingRed/>,<ThreeSubRating/>,<FourSubRating/>,<FiveSubRating/>] : [<OneRatingRed/>,<TwoRatingRed/>,<ThreeRating/>,<FourRating/>,<FiveRating/>]
	    else if(scoreValue > 2 && scoreValue < 4)
	      return type == 'subcompetency' ? [<OneRatingYellow/>,<TwoRatingYellow/>,<ThreeRatingYellow/>,<FourSubRating/>,<FiveSubRating/>] : [<OneRatingYellow/>,<TwoRatingYellow/>,<ThreeRatingYellow/>,<FourRating/>,<FiveRating/>]
	    else if(scoreValue >= 4)
	      return type == 'subcompetency' ? [<OneRatingGreen/>,<TwoRatingGreen/>,<ThreeRatingGreen/>,<FourRatingGreen/>,<FiveRatingGreen/>] : [<OneRatingGreen/>,<TwoRatingGreen/>,<ThreeRatingGreen/>,<FourRatingGreen/>,<FiveRatingGreen/>]
	    else
	      return type == 'subcompetency' ? [<OneSubRating/>,<TwoSubRating/>,<ThreeSubRating/>,<FourSubRating/>,<FiveSubRating/>] : [<OneRating/>,<TwoRating/>,<ThreeRating/>,<FourRating/>,<FiveRating/>]
	  }


}